var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"shimmer-overflow mt-2",class:_vm.$route.name == 'AddCustomer' ||
      _vm.$route.name == 'EditCustomer' ||
      _vm.$route.name == 'ActivateCustomer' ||
      _vm.$route.name == 'Registration'
        ? 'p-0'
        : ''},[_c('b-row',{staticClass:"mt-5"},_vm._l((_vm.shimmer),function(i,index){return _c('b-col',{key:index,staticClass:"mb-4 shimmer",attrs:{"cols":index == 3 || index == 7 ? '9' : '4'}},[_c('b-skeleton',{attrs:{"type":"input"}})],1)}),1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }